import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Login from "./pages/Login";
import LandingV2 from "./pages/LandingV2";
import Mobile from "./pages/Mobile";
import StockView from "./pages/StockView";
import UserPreferences from "./pages/UserPreferences";
import GeminiChat from "./pages/GeminiChat";
import EtlDebug from "./pages/EtlDebug";
import TestData from "./pages/TestData";
import TestNews from "./pages/TestNews";
import MobileRedirect from "./components/MobileRedirect";
import TopBar from "./components/TopBar";
import TermsOfService from "./pages/TermsOfService";
import "./components/TopBar.css";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/home" replace />;
};

// Layout wrapper for authenticated pages — renders TopBar + page content
const ProtectedLayout = ({ children }) => {
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to="/home" replace />;
  return (
    <>
      <TopBar />
      <div className="topbar-spacer" />
      {children}
    </>
  );
};

// Send pageview to Google Analytics on route change
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-JMKC65MREG', {
        page_path: location.pathname + location.search
      });
    }
  }, [location]);

  return null;
};

function App() {
  // Provision guest credentials immediately on startup if none exists
  if (typeof window !== "undefined" && !localStorage.getItem("token")) {
    localStorage.setItem("token", "guest_token");
    localStorage.setItem("userEmail", "guest@alffy.com");
    localStorage.setItem("userName", "Guest");
    localStorage.setItem("isGuest", "true");
  }

  return (
    <Router>
      <AnalyticsTracker />
      <MobileRedirect />
      <Routes>
        <Route path="/home" element={<LandingV2 />} />
        <Route path="/mobile" element={<Mobile />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/stockview"
          element={
            <ProtectedLayout>
              <StockView />
            </ProtectedLayout>
          }
        />
        <Route
          path="/user-preferences"
          element={
            <ProtectedLayout>
              <UserPreferences />
            </ProtectedLayout>
          }
        />
        {/* Chat route - only available in development */}
        {process.env.NODE_ENV !== 'production' && (
          <Route
            path="/chat"
            element={
              <ProtectedLayout>
                <GeminiChat />
              </ProtectedLayout>
            }
          />
        )}
        {/* ETL Debug route - only available in development */}
        {process.env.NODE_ENV !== 'production' && (
          <Route
            path="/etl-debug"
            element={
              <ProtectedLayout>
                <EtlDebug />
              </ProtectedLayout>
            }
          />
        )}
        {/* Data Comparison route - only available in development */}
        {process.env.NODE_ENV !== 'production' && (
          <Route
            path="/test-data"
            element={
              <ProtectedLayout>
                <TestData />
              </ProtectedLayout>
            }
          />
        )}
        {process.env.NODE_ENV !== 'production' && (
          <Route
            path="/test-news"
            element={
              <ProtectedLayout>
                <TestNews />
              </ProtectedLayout>
            }
          />
        )}
        {/* Default route — send visitors directly to Stock View */}
        <Route path="*" element={<Navigate to="/stockview" replace />} />
      </Routes>
    </Router>
  );
}

export default App;